webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Top_vue__ = __webpack_require__(8);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fdc32ff8_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Top_vue__ = __webpack_require__(54);
function injectStyle (ssrContext) {
  __webpack_require__(27)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Top_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fdc32ff8_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Top_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase_app__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase_app___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_firebase_app__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase_firestore__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_List__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_About__ = __webpack_require__(50);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Top',
  components: {
    List: __WEBPACK_IMPORTED_MODULE_3__components_List__["a" /* default */], About: __WEBPACK_IMPORTED_MODULE_4__components_About__["a" /* default */]
  },
  data: function data() {
    return {
      showAbout: false,
      dispGenre: "nothing",
      videos: {},
      inputUrl: null,
      inputGenre: "nothing",
      registLoading: false,
      resMessage: null
    };
  },

  methods: {

    //--------------
    // 登録処理
    //--------------
    regist: function regist() {
      var _this = this;

      // 処理中は無視
      if (this.registLoading) return;

      // 処理開始
      this.registLoading = true;
      this.resMessage = null;

      // functionsに処理を投げる
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("/registUrl", {
        "videoUrl": this.inputUrl,
        "genre": this.inputGenre
      })

      // functions完了時
      .then(function (response) {
        _this.registLoading = false;

        // 正常終了
        if (response.data == "success") {
          _this.resMessage = "登録しました！";
          location.reload();

          // エラー表示
        } else if (response.data == "id-error") {
          _this.resMessage = "動画のIDが不正です";
        } else if (response.data == "not-found-error") {
          _this.resMessage = "動画が見つかりませんでした";
        } else if (response.data == "age-restricted-error") {
          _this.resMessage = "年齢制限のある動画は登録できません";
        } else if (response.data == "same-video-error") {
          _this.resMessage = "同じ動画は1週間経つまで登録することはできません";
        } else if (response.data == "same-channel-error") {
          _this.resMessage = "同じチャンネルの動画は24時間経つまで登録することはできません";
        } else {
          _this.resMessage = "サーバーエラー：時間をおいてアクセスしてください";
        }

        alert(_this.resMessage);
      })

      // functionsエラー
      .catch(function (error) {
        _this.registLoading = false;
        _this.resMessage = "サーバーエラー：時間をおいてアクセスしてください";
        alert(_this.resMessage);
      });
    },

    //----------------------
    // 表示ジャンル切り替え
    //----------------------
    changeDispVideos: function changeDispVideos(genre) {
      this.dispGenre = genre;
    }
  }
});

/***/ }),
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase_app__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase_app___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_firebase_app__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase_firestore__ = __webpack_require__(20);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'List',
  props: {
    genre: String,
    videos: Object
  },
  data: function data() {
    return {
      videosLoading: false,
      endCreateDate: "2100-12-31",
      noMore: false
    };
  },

  methods: {

    //--------------
    // db取得処理
    //--------------
    getVideos: function getVideos() {
      var _this = this;

      // もうない
      if (this.noMore) return;

      // ロード中は無視
      if (this.videosLoading) return;

      // ロード開始
      this.videosLoading = true;

      // リファレンス
      var db = __WEBPACK_IMPORTED_MODULE_0_firebase_app___default.a.firestore();
      var videosRef = db.collection("videos").orderBy("createDate", "desc").limit(this.$moreAmount).startAfter(this.endCreateDate);

      // ジャンル指定時
      if (this.genre != "nothing") {
        videosRef = videosRef.where("genre", "==", this.genre);
      }

      // 取得
      videosRef.get().then(function (querySnapshot) {
        querySnapshot.forEach(function (doc) {
          var data = doc.data();
          data.id = doc.id;
          _this.videos[_this.genre].push(data);
        });

        // 読み込み位置を更新
        if (_this.videos[_this.genre].length > 0) {
          _this.endCreateDate = _this.videos[_this.genre].slice(-1)[0].createDate;
        }

        // 全部読み込んだ
        if (querySnapshot.docs.length == 0 || _this.videos[_this.genre].length >= _this.$maxAmount[_this.genre]) {
          _this.noMore = true;
        }

        // ロード終了
        _this.videosLoading = false;

        // 異常時
      }).catch(function (error) {

        // ロード終了
        _this.videosLoading = false;
        console.log(error);
      });
    },


    //------------------
    // スクロールロード
    //------------------
    onScroll: function onScroll() {

      // もうない
      if (this.noMore) return;

      // ロード中は無視
      if (this.videosLoading) return;

      // maxまで読み込んだら無視
      if (this.videos.length >= 6) return;

      // 画面端までいったら
      if (window.innerHeight + window.pageYOffset >= document.body.offsetHeight - 10) {
        this.getVideos();
      }
    }
  },

  //-------------
  // マウント時
  //-------------
  mounted: function mounted() {

    // 初めて表示した時
    if (!this.videos[this.genre]) {
      this.videos[this.genre] = [];
      this.getVideos();

      // 2回目以降の場合
    } else {

      // 一番下の登録日を更新（startAfterで使う）
      this.endCreateDate = this.videos[this.genre].slice(-1)[0].createDate;
    }

    // スクロールイベント登録
    window.addEventListener("scroll", this.onScroll);
  },


  //------------
  // 後片付け
  //------------
  destroyed: function destroyed() {

    // スクロールイベント削除
    window.removeEventListener("scroll", this.onScroll);
  }
});

/***/ }),
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ShareButton__ = __webpack_require__(51);
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'About',
  components: {
    ShareButton: __WEBPACK_IMPORTED_MODULE_0__components_ShareButton__["a" /* default */]
  }
});

/***/ }),
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ShareButton',
  data: function data() {
    return {
      url: "https://daredemo-youtube.com",
      title: "だれでも急上昇"
    };
  }
});

/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Top__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_firebase_app__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_firebase_app___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_firebase_app__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.





__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

//-----------------
// firebase初期化
//-----------------
var firebaseConfig = {
  apiKey: "AIzaSyAXj0Gt1jm6iNd-76ACsKLjw0tvygExYQk",
  authDomain: "daredemo-40b01.firebaseapp.com",
  databaseURL: "https://daredemo-40b01.firebaseio.com",
  projectId: "daredemo-40b01",
  storageBucket: "daredemo-40b01.appspot.com",
  messagingSenderId: "1093039856278",
  appId: "1:1093039856278:web:6432e09f7389a2df"
};

// Initialize Firebase
__WEBPACK_IMPORTED_MODULE_3_firebase_app___default.a.initializeApp(firebaseConfig);

//--------------
// 定数
//--------------
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$moreAmount = 10;
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$maxAmount = {
  nothing: 50,
  music: 30,
  game: 30,
  news: 30,
  movie: 30,
  anime: 30
};

//----------------
// 共通フィルター
//----------------
// firestore.timestampを（n分前）とかの簡易表示にする
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].filter("simpleDate", function (timestamp) {
  if (!timestamp) return "";
  var jsDate = timestamp.toDate();
  var jsSeconds = (Date.now() - jsDate.getTime()) / 1000;
  if (jsSeconds < 60) return "たった今";else if (jsSeconds < 60 * 60) return Math.floor(jsSeconds / 60) + "分前";else if (jsSeconds < 60 * 60 * 24) return Math.floor(jsSeconds / (60 * 60)) + "時間前";else if (jsSeconds < 60 * 60 * 24 * 365) return Math.floor(jsSeconds / (60 * 60 * 24)) + "日前";else return "1年以上前";
});

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  template: '<Top/>',
  components: { Top: __WEBPACK_IMPORTED_MODULE_1__components_Top__["a" /* default */] }
});

/***/ }),
/* 25 */,
/* 26 */,
/* 27 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_List_vue__ = __webpack_require__(21);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d0702c72_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_List_vue__ = __webpack_require__(49);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_List_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d0702c72_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_List_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 49 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._l((_vm.videos[_vm.genre]),function(video){return _c('a',{key:video.id,staticClass:"video",attrs:{"href":'https://www.youtube.com/watch?v=' + video.id}},[_c('div',{staticClass:"thumbnail"},[_c('img',{attrs:{"src":video.thumbnailUrl}}),_vm._v(" "),_c('div',{staticClass:"duration"},[_vm._v(_vm._s(video.duration))])]),_vm._v(" "),_c('div',{staticClass:"text"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(video.title))]),_vm._v(" "),_c('div',{staticClass:"channelTitle"},[_vm._v(_vm._s(video.channelTitle))]),_vm._v(" "),_c('div',{staticClass:"count-and-date"},[_vm._v("???万 回視聴・"+_vm._s(_vm._f("simpleDate")(video.createDate)))]),_vm._v(" "),_c('div',{staticClass:"description"},[_vm._v(_vm._s(video.description))]),_vm._v(" "),_vm._m(0,true),_vm._v(" "),_vm._m(1,true)])])}),_vm._v(" "),_c('div',{staticClass:"loader-frame"},[(_vm.videosLoading)?_c('div',{staticClass:"loader"}):_vm._e()])],2)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobile-channelIcon"},[_c('i',{staticClass:"fas fa-user-circle fa-2x face"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobile-threePoint"},[_c('i',{staticClass:"fas fa-ellipsis-v fa-lg"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_About_vue__ = __webpack_require__(22);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3377d10a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_About_vue__ = __webpack_require__(53);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_About_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3377d10a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_About_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 51 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ShareButton_vue__ = __webpack_require__(23);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2650b6dc_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ShareButton_vue__ = __webpack_require__(52);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ShareButton_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2650b6dc_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ShareButton_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 52 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"share"},[_c('div',{staticClass:"caption"},[_vm._v("このサイトをシェアする")]),_vm._v(" "),_c('a',{attrs:{"href":("https://twitter.com/share?url=" + _vm.url + "&text=" + _vm.title),"rel":"nofollow","target":"_blank"}},[_c('i',{staticClass:"fab fa-twitter-square fa-2x twitter"})]),_vm._v(" "),_c('a',{attrs:{"href":("http://www.facebook.com/share.php?u=" + _vm.url),"rel":"nofollow","target":"_blank"}},[_c('i',{staticClass:"fab fa-facebook-square fa-2x facebook"})]),_vm._v(" "),_c('a',{attrs:{"href":("https://social-plugins.line.me/lineit/share?url=(" + (encodeURIComponent(_vm.url)) + ")"),"rel":"nofollow","target":"_blank"}},[_c('i',{staticClass:"fab fa-line fa-2x line"})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',[_vm._v("\n    「だれでも急上昇」はどなたでもYouTubeの急上昇に載った時の雰囲気を味わうことのできる画期的なサイトです！画面一番上の入力欄に動画URLをコピペして登録ボタンを押すだけで、急上昇リストに追加されます。自作の動画や、おすすめの動画を貼って、みんなに見てもらいましょう！なお本家YouTube様とはなんの関係もございません。\n  ")]),_vm._v(" "),_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('ShareButton')],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v("\n    お問い合わせは"),_c('a',{staticClass:"link",attrs:{"href":"https://docs.google.com/forms/d/e/1FAIpQLScKjsSIBxw3fSsk-nB18Zok0nDGusbZr-o4jtCM5xgKuTmp4w/viewform?usp=sf_link","target":"_blank"}},[_vm._v("こちら")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v("\n    製作者の"),_c('a',{staticClass:"link",attrs:{"href":"https://twitter.com/ShimageW","target":"_blank"}},[_vm._v("Twitter")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 54 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('header',[_c('a',{staticClass:"logo",attrs:{"href":"javascript:void(0)"},on:{"click":function($event){_vm.showAbout = !_vm.showAbout}}},[_c('i',{staticClass:"fas fa-bars icon burger"}),_vm._v(" "),_c('i',{staticClass:"fas fa-fire fa-lg logoicon"}),_vm._v(" "),_c('div',{staticClass:"caption vmid"},[_vm._v("だれでも急上昇")])]),_vm._v(" "),_c('div',{staticClass:"register"},[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.regist($event)}}},[_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.inputUrl),expression:"inputUrl",modifiers:{"trim":true}}],attrs:{"type":"text","placeholder":"YouTubeの動画URLかIDを入力","spellcheck":"false"},domProps:{"value":(_vm.inputUrl)},on:{"input":function($event){if($event.target.composing){ return; }_vm.inputUrl=$event.target.value.trim()},"blur":function($event){return _vm.$forceUpdate()}}}),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.inputGenre),expression:"inputGenre"}],on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.inputGenre=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"nothing"}},[_vm._v("ジャンル")]),_vm._v(" "),_c('option',{attrs:{"value":"nothing"}},[_vm._v("なし")]),_vm._v(" "),_c('option',{attrs:{"value":"music"}},[_vm._v("音楽")]),_vm._v(" "),_c('option',{attrs:{"value":"game"}},[_vm._v("ゲーム")]),_vm._v(" "),_c('option',{attrs:{"value":"news"}},[_vm._v("ニュース")]),_vm._v(" "),_c('option',{attrs:{"value":"movie"}},[_vm._v("映画")]),_vm._v(" "),_c('option',{attrs:{"value":"anime"}},[_vm._v("アニメ")])]),_c('button',{attrs:{"type":"submit","disabled":_vm.registLoading}},[_vm._v("\n          登録\n          "),(_vm.registLoading)?_c('div',{staticClass:"loader"}):_vm._e()])])]),_vm._v(" "),_vm._m(0)]),_vm._v(" "),_c('div',{staticClass:"contents"},[_c('div',{staticClass:"menu"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"group"},[_vm._m(2),_vm._v(" "),_vm._m(3),_vm._v(" "),_vm._m(4),_vm._v(" "),_vm._m(5),_vm._v(" "),_c('div',{staticClass:"item"},[_c('a',{attrs:{"href":"javascript:void(0)"},on:{"click":function($event){_vm.showAbout = !_vm.showAbout}}},[_c('i',{staticClass:"fas fa-question icon"}),_c('span',{staticClass:"caption"},[_vm._v("このサイトについて")])])]),_vm._v(" "),(_vm.showAbout)?_c('About',{staticClass:"about"}):_vm._e()],1),_vm._v(" "),_c('footer',[_vm._v("© daredemo-youtube.com")])]),_vm._v(" "),_c('div',{staticClass:"main"},[(_vm.showAbout)?_c('About',{staticClass:"mobile-about"}):_vm._e(),_vm._v(" "),(_vm.dispGenre == 'nothing')?_c('div',{staticClass:"genre"},[_c('a',{attrs:{"href":"javascript:void(0)"},on:{"click":function($event){return _vm.changeDispVideos('music')}}},[_vm._m(6)]),_vm._v(" "),_c('a',{attrs:{"href":"javascript:void(0)"},on:{"click":function($event){return _vm.changeDispVideos('game')}}},[_vm._m(7)]),_vm._v(" "),_c('a',{attrs:{"href":"javascript:void(0)"},on:{"click":function($event){return _vm.changeDispVideos('news')}}},[_vm._m(8)]),_vm._v(" "),_c('a',{attrs:{"href":"javascript:void(0)"},on:{"click":function($event){return _vm.changeDispVideos('movie')}}},[_vm._m(9)]),_vm._v(" "),_c('a',{attrs:{"href":"javascript:void(0)"},on:{"click":function($event){return _vm.changeDispVideos('anime')}}},[_vm._m(10)])]):_c('div',{staticClass:"simple-genre"},[_c('a',{attrs:{"href":"javascript:void(0)"},on:{"click":function($event){return _vm.changeDispVideos('nothing')}}},[_vm._v("全て")]),_vm._v("・\n        "),_c('a',{class:{selected : _vm.dispGenre=='music'},attrs:{"href":"javascript:void(0)"},on:{"click":function($event){return _vm.changeDispVideos('music')}}},[_vm._v("音楽")]),_vm._v("・\n        "),_c('a',{class:{selected : _vm.dispGenre=='game'},attrs:{"href":"javascript:void(0)"},on:{"click":function($event){return _vm.changeDispVideos('game')}}},[_vm._v("ゲーム")]),_vm._v("・\n        "),_c('a',{class:{selected : _vm.dispGenre=='news'},attrs:{"href":"javascript:void(0)"},on:{"click":function($event){return _vm.changeDispVideos('news')}}},[_vm._v("ニュース")]),_vm._v("・\n        "),_c('a',{class:{selected : _vm.dispGenre=='movie'},attrs:{"href":"javascript:void(0)"},on:{"click":function($event){return _vm.changeDispVideos('movie')}}},[_vm._v("映画")]),_vm._v("・\n        "),_c('a',{class:{selected : _vm.dispGenre=='anime'},attrs:{"href":"javascript:void(0)"},on:{"click":function($event){return _vm.changeDispVideos('anime')}}},[_vm._v("アニメ")])]),_vm._v(" "),(_vm.dispGenre == 'nothing')?_c('List',{key:"1",attrs:{"genre":_vm.dispGenre,"videos":_vm.videos}}):_vm._e(),_vm._v(" "),(_vm.dispGenre == 'music')?_c('List',{key:"2",attrs:{"genre":_vm.dispGenre,"videos":_vm.videos}}):_vm._e(),_vm._v(" "),(_vm.dispGenre == 'game')?_c('List',{key:"3",attrs:{"genre":_vm.dispGenre,"videos":_vm.videos}}):_vm._e(),_vm._v(" "),(_vm.dispGenre == 'news')?_c('List',{key:"4",attrs:{"genre":_vm.dispGenre,"videos":_vm.videos}}):_vm._e(),_vm._v(" "),(_vm.dispGenre == 'movie')?_c('List',{key:"5",attrs:{"genre":_vm.dispGenre,"videos":_vm.videos}}):_vm._e(),_vm._v(" "),(_vm.dispGenre == 'anime')?_c('List',{key:"6",attrs:{"genre":_vm.dispGenre,"videos":_vm.videos}}):_vm._e()],1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"acount"},[_c('i',{staticClass:"fas fa-video icon"}),_vm._v(" "),_c('i',{staticClass:"fas fa-th icon"}),_vm._v(" "),_c('i',{staticClass:"fas fa-comment icon"}),_vm._v(" "),_c('i',{staticClass:"fas fa-bell icon"}),_vm._v(" "),_c('i',{staticClass:"fas fa-user-circle fa-2x icon face"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"group"},[_c('div',{staticClass:"item"},[_c('i',{staticClass:"fas fa-home icon"}),_c('span',{staticClass:"caption"},[_vm._v("ホーム")])]),_vm._v(" "),_c('div',{staticClass:"item selected"},[_c('i',{staticClass:"fas fa-fire icon"}),_c('span',{staticClass:"caption"},[_vm._v("急上昇")])]),_vm._v(" "),_c('div',{staticClass:"item"},[_c('i',{staticClass:"fas fa-caret-square-right icon"}),_c('span',{staticClass:"caption"},[_vm._v("登録チャンネル")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"item"},[_c('i',{staticClass:"fas fa-folder icon"}),_c('span',{staticClass:"caption"},[_vm._v("ライブラリ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"item"},[_c('i',{staticClass:"fas fa-history icon"}),_c('span',{staticClass:"caption"},[_vm._v("履歴")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"item"},[_c('i',{staticClass:"fas fa-clock icon"}),_c('span',{staticClass:"caption"},[_vm._v("後で見る")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"item"},[_c('i',{staticClass:"fas fa-thumbs-up icon"}),_c('span',{staticClass:"caption"},[_vm._v("高く評価した動画")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"btn"},[_c('div',{staticClass:"image"},[_c('i',{staticClass:"fas fa-music fa-2x"})]),_vm._v(" "),_c('div',{staticClass:"caption"},[_vm._v("音楽")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"btn"},[_c('div',{staticClass:"image"},[_c('i',{staticClass:"fas fa-gamepad fa-2x"})]),_vm._v(" "),_c('div',{staticClass:"caption"},[_vm._v("ゲーム")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"btn"},[_c('div',{staticClass:"image"},[_c('i',{staticClass:"fas fa-newspaper fa-2x"})]),_vm._v(" "),_c('div',{staticClass:"caption"},[_vm._v("ニュース")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"btn"},[_c('div',{staticClass:"image"},[_c('i',{staticClass:"fas fa-film fa-2x"})]),_vm._v(" "),_c('div',{staticClass:"caption"},[_vm._v("映画")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"btn"},[_c('div',{staticClass:"image"},[_c('i',{staticClass:"fas fa-grin fa-2x"})]),_vm._v(" "),_c('div',{staticClass:"caption"},[_vm._v("アニメ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 55 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Top__ = __webpack_require__(7);




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: "history",
  routes: [{
    path: '/',
    name: 'Top',
    component: __WEBPACK_IMPORTED_MODULE_2__components_Top__["a" /* default */]
  }]
}));

/***/ })
],[24]);


// WEBPACK FOOTER //
// static/js/app.8896ccd028449eed9a95.js